let objects = {
    token: 'token',
    profile: 'profile',
    sendCode: 'sendCode',
    tutorEnv: 'tutorEnv',
    currentTask: 'currentTask',
    talkAppId: 'talkAppId',

    toast: 'toast',
    toastMsg: 'toastMsg',
    fetchingNewUpdates: 'fetchingNewUpdates',
    connectionError: 'connectionError',
}
export default objects
